module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"panel filter-panel\"> <div id=\"carrier_picker\" class=\"filter\"></div> <div id=\"facility_type_picker\" class=\"filter\"></div> <div id=\"tracker_loader\" class=\"filter\"></div> </div> <div class=\"row\"> <div class=\"col-sm-8\"> <div class=\"us-map\"></div> </div> <div class=\"col-sm-4\"> <div class=\"facility-chart\"></div> <div class=\"facility-selector\"> <h4>Facilities</h4> <table class=\"table table-condensed table-hover\"> <tbody></tbody> </table> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_activity_map.ejs
// module id = 876
// module chunks = 1